import {
  InputProps as ChakraInputProps,
  Input as ChakraInput,
  Flex,
  FormControl,
  FormLabel,
  FormLabelProps,
} from '@chakra-ui/react';
import useTranslate from '~/common/utils/translate';
import InputMask from 'react-input-mask';
import React from 'react';

type InputProps = ChakraInputProps & {
  label?: string;
  labelAsPlaceholder?: boolean;
  row?: boolean;
  labelParams?: string[];
  params?: string[];
  labelProps?: FormLabelProps;
  masked?: boolean;
  mask?: string;
  maskChar?: string;
  formatChars?: object;
  alwaysShowMask?: boolean;
};

export const Input: React.FC<InputProps> = ({
  label,
  row = false,
  placeholder,
  labelParams,
  params,
  children,
  labelAsPlaceholder,
  labelProps,
  masked = false,
  ...props
}) => {
  const translate = useTranslate();
  return (
    <FormControl w="full">
      <Flex direction={row ? 'row' : 'column'} align="start">
        {!labelAsPlaceholder ? (
          <>
            {label && (
              <FormLabel {...labelProps}>
                {translate(label, labelParams)}
              </FormLabel>
            )}
          </>
        ) : null}
        {!masked ? (
          <ChakraInput
            placeholder={translate(
              !labelAsPlaceholder ? placeholder : label,
              params,
            )}
            {...props}
            borderColor="#807a7a"
          >
            {translate(children, params)}
          </ChakraInput>
        ) : (
          <ChakraInput
            placeholder={translate(
              !labelAsPlaceholder ? placeholder : label,
              params,
            )}
            as={InputMask}
            {...props}
          >
            {translate(children, params)}
          </ChakraInput>
        )}
      </Flex>
    </FormControl>
  );
};
